import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PageNotFoundComponent } from '../../generic-components/PageNotFound/PageNotFound.component';
import { PageLayoutsModule } from '../../page-layouts/page-layouts.module';

@NgModule({
    imports: [CommonModule, PageLayoutsModule],
    declarations: [PageNotFoundComponent],
    exports: [PageNotFoundComponent],
    providers: []
})
export class PageNotFoundModule {}
